import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  backToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}
